module.exports = __webpack_public_path__ + "static/media/arrow-up-with-dollar.f31800db.svg";